import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Calendar, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Schedule() {
  return (
    <div className="App">
      <Header />
      <section className="bg-navy text-white py-20" data-testid="schedule-hero">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="w-16 h-16 mx-auto rounded-lg bg-magenta/20 border border-magenta/40 flex items-center justify-center mb-6">
            <Calendar className="text-magenta" size={30} />
          </span>
          <h1 className="font-display text-4xl lg:text-5xl font-black">Schedule an Appointment</h1>
          <p className="mt-5 text-white/80 text-lg leading-relaxed">
            Meet with an AAWTA Enrollment Specialist to review your readiness, funding needs,
            qualifications, and next steps in the Driven Together Education Program.
          </p>
          <a href="https://aawta-hub.emergent.host/book/aawta" target="_blank" rel="noopener noreferrer"
             data-testid="schedule-book-button"
             className="mt-9 inline-flex items-center justify-center gap-2 bg-magenta hover:bg-magenta-dark text-white font-bold py-4 px-8 rounded-md transition-colors">
            Schedule With an Enrollment Specialist <ArrowRight size={18} />
          </a>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-dark-text/70">Not ready to schedule yet? Complete your intake first and we'll reach out.</p>
          <Link to="/intake" className="mt-4 inline-flex items-center gap-2 text-navy font-bold hover:text-magenta transition-colors">
            Start Your Intake <ArrowRight size={16} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
